async function createSample({
    well,
    name,
    primer,
    controlPrimerName,
    concentration,
    readLength,
    volume,
    type,
    sampleMap,
    order
}) {
    return fetch(`/api/samples`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            well,
            name,
            primer,
            controlPrimerName,
            concentration,
            readLength,
            volume,
            type,
            sampleMap,
            order
        })
    });
}

async function updateSample(id, {
    well,
    name,
    primer,
    controlPrimerName,
    concentration,
    readLength,
    volume,
    type,
    sampleMap,
    order
}) {
    return fetch(`/api/samples/${id}`, {
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            well,
            name,
            primer,
            controlPrimerName,
            concentration,
            readLength,
            volume,
            type,
            sampleMap,
            order
        })
    });
}

async function deleteSample(id) {
    return fetch(`/api/samples/${id}`, {
        method: 'DELETE',
    });
}

export {
    createSample,
    updateSample,
    deleteSample
}